export function lp(str?: string): [Document, string] {
  var msg = "[CVP] " + (str || "");
  return [window.document, msg.trim()];
}
